//
// ContentPage.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import Content from '../components/Content'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useParams } from 'react-router-dom'

function ContentPage() {
    const { name } = useParams();

    //const name = this.props.match.params.name;

    return (
        <div>
            <Header content={name} />
            <Content content={name} name={name} />
            <Footer />
        </div>
    )
}

export default ContentPage;
